module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"defaultPlaceholder":"Select option"},"de":{"defaultPlaceholder":"Bitte auswählen"},"fr":{"defaultPlaceholder":"Veuillez sélectionner"},"it":{"defaultPlaceholder":"Selezionare"}}')
  delete Component.options._Ctor
}
